"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSeparateUrl = void 0;
/**
 * Разбирает строку урла на части: { protocol, domain, path }
 */
var getSeparateUrl = function (url, locationPath) {
    var urlArray = url.match(/[^\/:]+/g);
    var _a = __read(urlArray), protocol = _a[0], domain = _a[1], otherPath = _a.slice(2);
    var lastItem = otherPath[otherPath.length - 1];
    var endlessSlash = lastItem && /\?/.test(lastItem)
        ? ''
        : '/';
    var path = "/".concat(otherPath.slice(0, otherPath.length).join('/')).concat(endlessSlash);
    if (locationPath) {
        path = locationPath;
    }
    else if (!otherPath.length) {
        path = '';
    }
    return {
        domain: domain,
        path: path,
        protocol: protocol,
    };
};
exports.getSeparateUrl = getSeparateUrl;
//# sourceMappingURL=getSeparateUrl.js.map